<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('trainerProfile.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('trainerProfile.pageTitle'),
            href: '/admin/academic/trainer-profiles',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-3">
            <profile v-model="model" :validate="errors" class="tw-h-full" />
          </div>
          <div class="col-md-9">
            <ts-panel>
              <ts-panel-wrapper>
                <form class="form-horizontal form-horizontal-text-right">
                  <details-template v-model="model" :validation="errors" />
                  <address-template v-model="model" :validation="errors" />
                  <skill-level-detail-template
                    v-model="model"
                    :validation="errors"
                  />
                </form>
              </ts-panel-wrapper>
            </ts-panel>
          </div>
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'trainer-profile' })"
        :disabled="waiting_new || waiting"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button
        color="primary"
        outline
        :waiting="waiting_new"
        :disabled="waiting_new || waiting"
        @click.prevent="onSaveAddNew"
      >
        {{ $t("saveAddNew") }}</ts-button
      >
      <ts-button
        color="primary"
        :waiting="waiting"
        :disabled="waiting_new || waiting"
        @click.prevent="onSave"
      >
        {{ $t("save") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import Profile from "./components/profile.vue";
import DetailsTemplate from "./components/detail.vue";
import AddressTemplate from "./components/address.vue";
import SkillLevelDetailTemplate from "./components/skill-level-detail.vue";
import { mapActions } from "vuex";
import { Errors } from "form-backend-validation";
import moment from "moment";

export default {
  name: "trainerProfileCreate",
  components: {
    Profile,
    DetailsTemplate,
    AddressTemplate,
    SkillLevelDetailTemplate,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        fname_kh: "",
        lname_kh: "",
        fname_en: "",
        lname_en: "",
        sex: null,
        dob: moment().format("DD-MM-YYYY"),
        nationality_id: null,
        register_date: moment().format("DD-MM-YYYY"),
        phone: null,
        email: null,
        telegram: null,
        facebook: null,
        line: null,
        title: null,
        marital_status: null,
        emergency_contact: null,
        province_code: null,
        district_code: null,
        commune_code: null,
        village_code: null,
        more_detail_address: null,
        occupation_en: null,
        occupation_kh: null,
        cultural_level: null,
        exam_session: null,
        foreign_languages: null,
        pob: null,
        pob_kh: null,
        is_external: false,
        ref_candidate_id: null,
        photo: null,
        skill_level_detail: [],
      },
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  methods: {
    ...mapActions("academic/trainerProfile", ["getFormViewData"]),
    async fetchFormViewModel({ params, index }) {
      this.waiting = true;
      await this.getFormViewData({
        index: index,
        params: params,
      });
      this.waiting = false;
    },
    async photoUpload(trainer_id) {
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        let formData = new FormData();
        formData.append("file", this.model.photo);
        formData.append("trainer_id", trainer_id);
        let response = await this.$store.dispatch(
          "academic/trainerProfile/photoUpload",
          formData
        );
        this.model.photo = response;
      }
      return "";
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting_new = true;
      this.$store
        .dispatch(
          "academic/trainerProfile/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          await this.photoUpload(this.model.trainer_id);
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting_new = false;
        });
    },
    async onSave() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/trainerProfile/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          await this.photoUpload(response.trainer_id);
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
          this.$router.push({ name: "trainer-profile" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearInput() {
      (this.model.fname_kh = ""),
        (this.model.lname_kh = ""),
        (this.model.fname_en = ""),
        (this.model.lname_en = ""),
        (this.model.name_en = null),
        (this.model.sex = null),
        (this.model.dob = moment().format("DD-MM-YYYY")),
        (this.model.nationality_id = null),
        (this.model.register_date = moment().format("DD-MM-YYYY")),
        (this.model.phone = null),
        (this.model.email = null),
        (this.model.photo = null),
        (this.model.telegram = null),
        (this.model.facebook = null),
        (this.model.line = null),
        (this.model.title = null),
        (this.model.marital_status = null),
        (this.model.emergency_contact = null),
        (this.model.province_code = null),
        (this.model.district_code = null),
        (this.model.commune_code = null),
        (this.model.village_code = null),
        (this.model.more_detail_address = null),
        (this.model.occupation_en = null),
        (this.model.occupation_kh = null),
        (this.model.cultural_level = null),
        (this.model.exam_session = null),
        (this.model.foreign_languages = null),
        (this.model.pob = null),
        (this.model.pob_kh = null),
        (this.model.is_external = false),
        (this.model.ref_candidate_id = null),
        (this.model.skill_level_detail = []);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchFormViewModel({ params: {}, index: undefined });
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
